export class CompanyInfos {
    companyId;
    name = null;
    email = null;
    firstname = null;
    companyname = null;
    slug = null;
    description = null;
    lastname = null;
    street = null;
    zip = null;
    city = null;
    country = null;
    website = null;
    phone = null;
    customTermsUrl = null;
    customPrivacyUrl = null;
    constructor(companyId, data) {
        this.companyId = companyId;
        let definedKeys = Object.keys(this).filter((key) => key != "id");
        for (let key in data) {
            let value = data[key];
            let keyIsDefinedOnInstance = definedKeys.includes(key);
            if (keyIsDefinedOnInstance) {
                if (value) {
                    //replace all firebase dates with real dates
                    if (value.seconds && value.toDate) {
                        value = value.toDate();
                    }
                }
                Object.assign(this, { [key]: value });
            }
        }
    }
}
